import React, { useContext, useEffect } from 'react';
import Header from './Header';
import { Footer } from './Footer';
import Loading from '../utility/Loading';
import LoaderHelper from '../utility/Loading/LoaderHelper';
import { ToastContainer } from 'react-toastify';
import AuthPopup from './AuthPopup';
import MobileStickyCTA from './MobileStickyCTA';
import { UserContext } from '../context/UserContext';
import { useLocation } from 'react-router-dom';
import Ads from './Ads';

interface LayoutProps {
  children: React.ReactNode;
  openPopup: (signUpMode?: boolean) => void;
  isPopupOpen: boolean;
  isSignUp?: boolean;
  closePopup: () => void;
  referral: string | null;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  openPopup,
  isPopupOpen,
  isSignUp = false,
  closePopup,
  referral
}) => {
  const location = useLocation();
  const isSymbolPage = /^\/[^/]+\/.+/.test(location.pathname);
  const isHallOfFamePage = location.pathname.startsWith('/hall-of-fame');
  const isWidePage = isSymbolPage || isHallOfFamePage;
  const userContext = useContext(UserContext);

  // Open auth popup when any page dispatches the custom event
  useEffect(() => {
    const handler = () => openPopup();
    window.addEventListener('sf-open-auth', handler as any);
    return () => window.removeEventListener('sf-open-auth', handler as any);
  }, [openPopup]);

  return <div className="flex flex-col min-h-screen relative bg-theme-primary dark-mode">
    {/* Authentication Popup */}
    <AuthPopup isOpen={isPopupOpen && userContext?.popupText === 'nopopup'} onClose={closePopup} referral={referral} signUp={isSignUp} />
    {/* Decorative elements */}
    <ToastContainer />
    <Loading ref={ref => LoaderHelper.setLoader(ref)} />
    <Header openPopup={openPopup} />
    <main className="flex-grow relative z-10 transition-all duration-300 ease-in-out">
      <div className={`page-transition-wrapper ${isWidePage ? 'max-w-none w-full mx-0 px-0' : 'max-w-screen-2xl w-full mx-auto'}`}>{children}</div>
    </main>
    {/* Mobile sticky CTA */}
    <MobileStickyCTA openPopup={openPopup} />
    <Ads />
    <Footer openPopup={openPopup} />
  </div>;
};

export default Layout;